import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Categories from "@/pages/Categories";
import CategoryPage from "@/pages/CategoryPage";
import Membership from "@/pages/Membership";
import SubmitEvent from "@/pages/SubmitEvent";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Favorites from "@/pages/Favorites";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Store from "@/pages/Store";
import ProductDetail from "@/pages/ProductDetail";
import Directory from "@/pages/Directory";
import DirectoryProfile from "@/pages/DirectoryProfile";
import JoinDirectory from "@/pages/JoinDirectory";
import Editorial from "@/pages/Editorial";
import Campfire from "@/pages/Campfire";
import { Navigate, useParams } from "react-router-dom";
function ArticleRedirect() { const { slug } = useParams(); return <Navigate to={`/campfire/${slug}`} replace />; }
import Article from "@/pages/Article";
import Alerts from "@/pages/Alerts";
import Community from "@/pages/Community";
import CommunityPost from "@/pages/CommunityPost";
import ClassifiedListings from "@/pages/ClassifiedListings";
import ListingDetail from "@/pages/ListingDetail";
import CommunityMembers from "@/pages/CommunityMembers";
import Notifications from "@/pages/Notifications";
import AdminCommunity from "@/pages/AdminCommunity";
import AdminCommunityModeration from "@/pages/AdminCommunityModeration";
import Messages from "@/pages/Messages";
import PublicProfile from "@/pages/PublicProfile";
import CantonPage from "@/pages/CantonPage";
import Cantons from "@/pages/Cantons";
import LunarCalendar from "@/pages/LunarCalendar";
import Concerts from "@/pages/Concerts";
import Radar from "@/pages/Radar";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Festivals from "@/pages/Festivals";
import Organizers from "@/pages/Organizers";
import Around from "@/pages/Around";
import BecomePartner from "@/pages/BecomePartner";
import Partners from "@/pages/Partners";
import Professionals from "@/pages/Professionals";
import ProfessionalDetail from "@/pages/ProfessionalDetail";
import ProProfileEdit from "@/pages/ProProfileEdit";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import PublishOpportunity from "@/pages/PublishOpportunity";
import ProDashboard from "@/pages/ProDashboard";
import OrganizerDashboard from "@/pages/OrganizerDashboard";
import Support from "@/pages/Support";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import NoIndexGuard from "@/components/NoIndexGuard";

function AppRouter() {  const location = useLocation();
  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <NoIndexGuard />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/map" element={<Events initialView="map" />} />
        <Route path="/events/:slug" element={<EventDetail />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/category/:cat" element={<CategoryPage />} />
        <Route path="/store" element={<Store />} />
        <Route path="/store/:slug" element={<ProductDetail />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="/directory/join" element={<JoinDirectory />} />
        <Route path="/directory/:slug" element={<DirectoryProfile />} />
        <Route path="/campfire" element={<Campfire />} />
        <Route path="/campfire/:slug" element={<Article />} />
        <Route path="/journal" element={<Navigate to="/campfire" replace />} />
        <Route path="/journal/:slug" element={<ArticleRedirect />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/post/:id" element={<CommunityPost />} />
        <Route path="/community/members" element={<CommunityMembers />} />
        <Route path="/community/me" element={<Community initialTab="mine" />} />
        <Route path="/community/annonces" element={<ClassifiedListings />} />
        <Route path="/community/annonces/:id" element={<ListingDetail />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/admin/community" element={<AdminCommunity />} />
        <Route path="/admin/community/moderation" element={<AdminCommunityModeration />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/:userId" element={<Messages />} />
        <Route path="/u/:userId" element={<PublicProfile />} />
        <Route path="/cantons" element={<Cantons />} />
        <Route path="/canton/:code" element={<CantonPage />} />
        <Route path="/support" element={<Support />} />
        <Route path="/lune" element={<LunarCalendar />} />
        <Route path="/concerts" element={<Concerts />} />
        <Route path="/radar" element={<Radar />} />
        <Route path="/artistes" element={<Artists />} />
        <Route path="/artistes/:slug" element={<ArtistDetail />} />
        <Route path="/festivals" element={<Festivals />} />
        <Route path="/organisateurs" element={<Organizers />} />
        <Route path="/autour" element={<Around />} />
        <Route path="/devenir-partenaire" element={<BecomePartner />} />
        <Route path="/partenaires" element={<Partners />} />
        <Route path="/professionnels" element={<Professionals />} />
        <Route path="/professionnels/:slug" element={<ProfessionalDetail />} />
        <Route path="/artisans" element={<Professionals defaultCategory="artisan" title="Artisans" desc="Forgerons, cuir, bois, textile, céramique, bijoux… les artisans de l'univers Pagan, Viking et médiéval en Suisse." />} />
        <Route path="/pro/fiche" element={<ProProfileEdit />} />
        <Route path="/opportunites" element={<Opportunities />} />
        <Route path="/opportunites/:slug" element={<OpportunityDetail />} />
        <Route path="/publier-une-opportunite" element={<PublishOpportunity />} />
        <Route path="/pro" element={<ProDashboard />} />
        <Route path="/pro/organisateur" element={<OrganizerDashboard />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/submit" element={<SubmitEvent />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/login" element={<Login />} />
        <Route path="/legal/:page" element={<Legal />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <AppRouter />
              <Toaster position="top-center" theme="dark" richColors />
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
